import { ReactElement } from "react";

export const BuildingIcon = (color?: string): ReactElement => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_373_194696)">
        <path
          d="M2 14H14"
          stroke={color ?? '#303E47'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 5.33333H6.66667"
          stroke={color ?? '#303E47'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M6 8H6.66667" stroke="#303E47" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M6 10.6667H6.66667"
          stroke={color ?? '#303E47'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.33333 5.33333H9.99999"
          stroke={color ?? '#303E47'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.33333 8H9.99999"
          stroke={color ?? '#303E47'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.33333 10.6667H9.99999"
          stroke={color ?? '#303E47'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.33333 14V3.33333C3.33333 2.97971 3.4738 2.64057 3.72385 2.39052C3.9739 2.14048 4.31304 2 4.66666 2H11.3333C11.6869 2 12.0261 2.14048 12.2761 2.39052C12.5262 2.64057 12.6667 2.97971 12.6667 3.33333V14"
          stroke={color ?? '#303E47'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_373_194696">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
